import { getSettings } from '@app/src/configuration/config.service';
import { HttpStatus } from '@app/src/utils/validations/constants';
import axios from 'axios';
import { hydrateUserService } from './hydrators';

export const servicesUserService = {
  async listServicesByUser(url) {
    try {

      const whitelist = Object.values(getSettings()).filter(value => value.startsWith('https://') || value.startsWith('http://'));
      const accessToken = sessionStorage.getItem('accessToken');
      if(whitelist.includes(url)){
        var data = await axios.get(url, {
          headers: { Authorization: `Bearer ${accessToken}` }
        });

        if (data.data.code === HttpStatus.LOGIN_SESSIONTOKEN_ERROR) {
          return null;
        }
        return hydrateUserService(data.data);
      }else{
        return null;
      }

    } catch (e) {
      throw e.response.data;
    }
  },
  async setService(value: string, url) {
    try {

      const whitelist = Object.values(getSettings()).filter(value => value.startsWith('https://') || value.startsWith('http://'));
      const accessToken = sessionStorage.getItem('accessToken');
      const refreshToken = localStorage.getItem('refreshtoken');
      const expToken = sessionStorage.getItem('accessToken');
      if(whitelist.includes(url)){
        var { data, headers } = await axios.post(url, { IdServicio: value, refreshToken, expToken }, {
          headers: { Authorization: `Bearer ${accessToken}` }
        });
        if (data.data.code === HttpStatus.LOGIN_SESSIONTOKEN_ERROR) {
          return false;
        }
        const refreshtoken = headers.authorization;
        localStorage.setItem('refreshtoken', refreshtoken);
        sessionStorage.setItem('accessToken', data.data.accessToken);
        sessionStorage.setItem('reportToken', data.data.reportToken);
        return true;
      }else{
        return false;
      }

    } catch (e) {
      throw e;
    }
  }
}
